import { atom } from 'jotai';
import {
  Commission,
  CommissionFilters,
  CommissionPaginationArgs,
  DateRangeOptions,
  InvoiceWorkingPaginationArgs,
  InvoiceWorking,
  PaymentStatus,
  PayoutCommissionsSortTermAtomType,
  PayoutCommissionsSortType,
  PayoutCommissionsSortTypes,
  SortFields,
} from '../typings';
import { atomWithReset } from 'jotai/utils';
import { createPaginatedRequestAtom } from '../../../utils/atoms/request-atom';
import { SortDirection } from '../../referral-leads/typings';

export const commissionsListAtom = createPaginatedRequestAtom<
  Commission,
  CommissionPaginationArgs
>();

export const invoiceWorkingListAtom = createPaginatedRequestAtom<
  InvoiceWorking,
  InvoiceWorkingPaginationArgs
>();

export const commisionPaymentStatusFilterAtom = atom<PaymentStatus | undefined>(
  undefined
);

export const commissionDateRangeFilterAtom = atom<DateRangeOptions>(
  DateRangeOptions.LAST_12_MONTHS
);

export const commissionsSortTermAtom =
  atomWithReset<PayoutCommissionsSortTermAtomType>({
    key: PayoutCommissionsSortTypes.newest_first,
    sortFilter: SortFields.dateCreated,
    direction: SortDirection.DESC,
  });

export const commissionsSortTermAtomReducer = (
  prev: PayoutCommissionsSortTermAtomType,
  action: PayoutCommissionsSortType
): PayoutCommissionsSortTermAtomType => {
  if (action.type === PayoutCommissionsSortTypes.newest_first) {
    return {
      ...prev,
      sortFilter: SortFields.dateCreated,
      direction: SortDirection.DESC,
      key: action.type,
    };
  }
  if (action.type === PayoutCommissionsSortTypes.oldest_first) {
    return {
      ...prev,
      sortFilter: SortFields.dateCreated,
      direction: SortDirection.ASC,
      key: action.type,
    };
  }
  if (action.type === PayoutCommissionsSortTypes.highest_amount) {
    return {
      ...prev,
      sortFilter: SortFields.amount,
      direction: SortDirection.ASC,
      key: action.type,
    };
  }
  if (action.type === PayoutCommissionsSortTypes.lowest_amount) {
    return {
      ...prev,
      sortFilter: SortFields.amount,
      direction: SortDirection.DESC,
      key: action.type,
    };
  }
  if (action.type === PayoutCommissionsSortTypes.reset) {
    return {
      sortFilter: SortFields.dateCreated,
      direction: SortDirection.DESC,
      key: PayoutCommissionsSortTypes.newest_first,
    };
  }

  return prev;
};

export const currentDateRangeAtom = atom<{
  startDate?: string;
  endDate?: string;
}>({});

export const selectedCommisionItemAtom = atom<Commission | null>(null);
